import styled from 'styled-components'

import { useTranslation } from '@root/shared/localization'

import { PremiumListItemButton } from '../common/premium-list-item-button'

type Props = {
  onBuyAgain?: () => void
}

export const ExpiredPremiumListItemBuy: React.FC<Props> = ({ onBuyAgain }) => {
  const { t } = useTranslation()

  return (
    <Root variant="soft" onClick={onBuyAgain} radius="rounded">
      {t('premium.button.buy-again')}
    </Root>
  )
}

export const Root = styled(PremiumListItemButton)`
  color: var(--subscriptionButton-9);
`
